import React, { useState, useContext, useEffect } from 'react';
import { BiChevronUp } from 'react-icons/bi';
import { FaCheck } from 'react-icons/fa';
import { ClubFittingContext } from "../../ClubfittingNew/ClubFittingContext";
import { FaArrowsAltV, FaArrowsAltH } from "react-icons/fa";
import StickSvg from '../Clubfitting SvgData view/StickSvg';
const IronsData = ({ step, iron, title, options, number, shotOpction, defaultSelected }) => {
    // const { defaultSelected, setdefaultSelected, updateremotefitting } = useContext(ClubFittingContext);


    const [dropdownState, setDropdownState] = useState({
        isOpen1: false,
        isOpen2: false,
        isOpen3: false,
        isOpenx: false,
        isOpeny: false
    });

    const [dropdownState2, setDropdownState2] = useState({
        isOpen1: false,
        isOpen2: false,
        isOpen3: false,
        isOpenx: false,
        isOpeny: false
    });
    const [dropdownState3, setDropdownState3] = useState({
        isOpen1: false,
        isOpen2: false,
        isOpen3: false,
        isOpenx: false,
        isOpeny: false
    });


    const handleToggleDropdown = (dropdownName) => {
        setDropdownState((prevState) => ({
            ...prevState,
            [dropdownName]: !prevState[dropdownName],
        }));
    };

    const handleToggleDropdown2 = (dropdownName) => {
        setDropdownState2((prevState) => ({
            ...prevState,
            [dropdownName]: !prevState[dropdownName],
        }));
    };

    const handleToggleDropdown3 = (dropdownName) => {
        setDropdownState3((prevState) => ({
            ...prevState,
            [dropdownName]: !prevState[dropdownName],
        }));
    }


    const handleOptionClick1 = (option, path) => {
        //  updateremotefitting(path, option.text);
    };

    const handleOptionClickResult = (option, path) => {
        // updateremotefitting(path, option.text);
    }

    useEffect(() => {
        // set all dropedown to false
        setDropdownState({
            isOpen1: false,
            isOpen2: false,
            isOpen3: false,
            isOpenx: false,
            isOpeny: false
        });

        setDropdownState2({
            isOpen1: false,
            isOpen2: false,
            isOpen3: false,
        });

        setDropdownState3({
            isOpen1: false,
            isOpen2: false,
            isOpen3: false,
        });

    }, [defaultSelected])

    return (
        <>
            <div className="new-design-border-sec">
                <div className="sec-header-dash border-header-sec new-design-header white">
                    <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                        <h3 className="box-title-lable">
                            <span className="color">{number}</span> {title}
                        </h3>
                    </div>
                    <div className="content-box-btn">
                        <div className={`head_check ${defaultSelected ? 'active' : ''}`}>
                            <FaCheck />
                        </div>
                    </div>
                </div>

                <div className={`form-box-color custom-select-container  p-0 ${dropdownState.isOpen1 ? 'open' : ''}`}>
                    <label className="dashboard-form-lable new-design-label">Shot 1</label>
                    <div className="arrow_svg_image">
                        <div className='svg-image-design mb-5'>
                            <StickSvg color={title} shot={1} level={iron} step={step} defaultSelected={defaultSelected} />
                        </div>
                    </div>
                    <div className="custom-form-group new-design-form-group">
                        <label className="dashboard-form-lable">Shot Strike</label>
                        <div className="w-60">
                            {/* <div className={`custom-select-wrapper mb-3 w-100 ${dropdownState.isOpen3 ? 'open' : ''}`}>
                                        <div
                                            className={`selected-option ${defaultSelected ? 'selected' : ''}`}
                                        >
                                            <div className="custom-option-label2">
                                                <span className="option-text">
                                                    {defaultSelected && defaultSelected[step] && defaultSelected[step][iron] && defaultSelected[step][iron].shot1 && defaultSelected[step][iron].shot1.option3 ? defaultSelected[step][iron].shot1.option3 : 'Shot Strike'}
                                                </span>
                                            </div>
                                            <i className={`bi ${dropdownState.isOpen3 ? 'bi-chevron-up' : 'bi-chevron-down'}`} />
                                        </div>
                                    </div> */}
                            <div className='drop-down-wrapper d-flex gap-3'>
                                <div className={`custom-select-wrapper w-50 ${dropdownState.isOpenx ? 'open' : ''}`}>
                                    <div className={`selected-option ${defaultSelected && defaultSelected[step] && defaultSelected[step][iron] && defaultSelected[step][iron].shot1 && defaultSelected[step][iron].shot1.optionx ? 'selected' : ''}`}>
                                        <div className="custom-option-label2">
                                            <span className="option-text">{defaultSelected[step][iron].shot1.optionx ? defaultSelected[step][iron].shot1.optionx : <FaArrowsAltH />}</span>
                                        </div>
                                        <i className={`bi ${dropdownState.isOpenx ? 'bi-chevron-up' : 'bi-chevron-down'}`} />
                                    </div>
                                </div>

                                <div className={`custom-select-wrapper w-50 ${dropdownState.isOpeny ? 'open' : ''}`} >
                                    <div className={`selected-option ${defaultSelected && defaultSelected[step] && defaultSelected[step][iron] && defaultSelected[step][iron].shot1 && defaultSelected[step][iron].shot1.optiony ? 'selected' : ''}`}>
                                        <div className="custom-option-label2">
                                            <span className="option-text">{defaultSelected[step][iron].shot1.optiony ? defaultSelected[step][iron].shot1.optiony : <FaArrowsAltV />}</span>
                                        </div>
                                        <i className={`bi ${dropdownState.isOpenx ? 'bi-chevron-up' : 'bi-chevron-down'}`} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="custom-form-group new-design-form-group">
                        <label className="dashboard-form-lable">Shot Shape</label>
                        <div className="w-60">
                            <div className={`custom-select-wrapper w-100 ${dropdownState.isOpen1 ? 'open' : ''}`}>
                                <div
                                    className={`selected-option ${defaultSelected ? 'selected' : ''}`}
                                >
                                    <div className="custom-option-label2">
                                        <span className="option-text">
                                            {defaultSelected && defaultSelected[step] && defaultSelected[step][iron] && defaultSelected[step][iron].shot1 && defaultSelected[step][iron].shot1.option1 ? defaultSelected[step][iron].shot1.option1 : 'Shot Shape'}
                                            {/* {defaultSelected[step][iron].shot1.option1 ? defaultSelected[step][iron].shot1.option1 : 'Shot Shape'} */}
                                        </span>
                                    </div>
                                    <i className={`bi ${dropdownState.isOpen1 ? 'bi-chevron-up' : 'bi-chevron-down'}`} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="custom-form-group new-design-form-group">
                        <label className="dashboard-form-lable">Shot Result</label>
                        <div className="w-60">
                            <div className={`custom-select-wrapper w-100 ${dropdownState.isOpen2 ? 'open' : ''}`}>
                                <div
                                    className={`selected-option ${defaultSelected ? 'selected' : ''}`}
                                >
                                    <div className="custom-option-label2">
                                        <span className="option-text">
                                            {defaultSelected && defaultSelected[step] && defaultSelected[step][iron] && defaultSelected[step][iron].shot1 && defaultSelected[step][iron].shot1.option2 ? defaultSelected[step][iron].shot1.option2 : 'Shot Result'}
                                            {/* {defaultSelected[step][iron].shot1.option2 ? defaultSelected[step][iron].shot1.option2 : 'Shot Result'} */}
                                        </span>
                                    </div>
                                    <i className={`bi ${dropdownState.isOpen2 ? 'bi-chevron-up' : 'bi-chevron-down'}`} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={`form-box-color custom-select-container  p-0 ${dropdownState2.isOpen1 ? 'open' : ''}`}>
                    <label className="dashboard-form-lable new-design-label">Shot 2</label>
                    <div className="arrow_svg_image">
                        <div className='svg-image-design mb-5'>
                            <StickSvg color={title} shot={2} level={iron} step={step} defaultSelected={defaultSelected}/>
                        </div>
                    </div>
                    <div className="custom-form-group new-design-form-group">
                        <label className="dashboard-form-lable">Shot Strike</label>
                        <div className="w-60">
                            {/* <div className={`custom-select-wrapper mb-3 w-100 ${dropdownState.isOpen3 ? 'open' : ''}`}>
                                        <div
                                            className={`selected-option ${defaultSelected ? 'selected' : ''}`}
                                        >
                                            <div className="custom-option-label2">
                                                <span className="option-text">
                                                    {defaultSelected && defaultSelected[step] && defaultSelected[step][iron] && defaultSelected[step][iron].shot1 && defaultSelected[step][iron].shot1.option3 ? defaultSelected[step][iron].shot1.option3 : 'Shot Strike'}
                                                </span>
                                            </div>
                                            <i className={`bi ${dropdownState.isOpen3 ? 'bi-chevron-up' : 'bi-chevron-down'}`} />
                                        </div>
                                    </div> */}
                            <div className='drop-down-wrapper d-flex gap-3'>
                                <div className={`custom-select-wrapper w-50 ${dropdownState.isOpenx ? 'open' : ''}`}>
                                    <div className={`selected-option ${defaultSelected && defaultSelected[step] && defaultSelected[step][iron] && defaultSelected[step][iron].shot2 && defaultSelected[step][iron].shot2.optionx ? 'selected' : ''}`}>
                                        <div className="custom-option-label2">
                                            <span className="option-text">{defaultSelected[step][iron].shot2.optionx ? defaultSelected[step][iron].shot2.optionx : <FaArrowsAltH />}</span>
                                        </div>
                                        <i className={`bi ${dropdownState.isOpenx ? 'bi-chevron-up' : 'bi-chevron-down'}`} />
                                    </div>
                                </div>

                                <div className={`custom-select-wrapper w-50 ${dropdownState.isOpeny ? 'open' : ''}`} >
                                    <div className={`selected-option ${defaultSelected && defaultSelected[step] && defaultSelected[step][iron] && defaultSelected[step][iron].shot2 && defaultSelected[step][iron].shot2.optiony ? 'selected' : ''}`}>
                                        <div className="custom-option-label2">
                                            <span className="option-text">{defaultSelected[step][iron].shot2.optiony ? defaultSelected[step][iron].shot2.optiony : <FaArrowsAltV />}</span>
                                        </div>
                                        <i className={`bi ${dropdownState.isOpenx ? 'bi-chevron-up' : 'bi-chevron-down'}`} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="custom-form-group new-design-form-group">
                        <label className="dashboard-form-lable">Shot Shape</label>
                        <div className="w-60">
                            <div className={`custom-select-wrapper w-100 ${dropdownState2.isOpen1 ? 'open' : ''}`}>
                                <div
                                    className={`selected-option ${defaultSelected ? 'selected' : ''}`}
                                >
                                    <div className="custom-option-label2">
                                        <span className="option-text">
                                            {defaultSelected && defaultSelected[step] && defaultSelected[step][iron] && defaultSelected[step][iron].shot2 && defaultSelected[step][iron].shot2.option1 ? defaultSelected[step][iron].shot2.option1 : 'Shot Shape'}
                                            {/* {defaultSelected[step][iron].shot2.option1 ? defaultSelected[step][iron].shot2.option1 : 'Shot Shape'} */}
                                        </span>
                                    </div>
                                    <i className={`bi ${dropdownState2.isOpen1 ? 'bi-chevron-up' : 'bi-chevron-down'}`} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="custom-form-group new-design-form-group">
                        <label className="dashboard-form-lable">Shot Result</label>
                        <div className="w-60">

                            <div className={`custom-select-wrapper mb-3 w-100 ${dropdownState2.isOpen2 ? 'open' : ''}`}>
                                <div
                                    className={`selected-option ${defaultSelected ? 'selected' : ''}`}
                                >
                                    <div className="custom-option-label2">
                                        <span className="option-text">
                                            {defaultSelected && defaultSelected[step] && defaultSelected[step][iron] && defaultSelected[step][iron].shot2 && defaultSelected[step][iron].shot2.option2 ? defaultSelected[step][iron].shot2.option2 : 'Shot Result'}
                                            {/* {defaultSelected[step][iron].shot2.option2 ? defaultSelected[step][iron].shot2.option2 : 'Shot Result'} */}
                                        </span>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <div className={`form-box-color custom-select-container  p-0 ${dropdownState3.isOpen1 ? 'open' : ''}`}>
                    <label className="dashboard-form-lable new-design-label">Shot 3</label>
                    <div className="arrow_svg_image">
                        <div className='svg-image-design mb-5'>
                            <StickSvg color={title} shot={3} level={iron} step={step}  defaultSelected={defaultSelected}/>
                        </div>
                    </div>
                    <div className="custom-form-group new-design-form-group">
                        <label className="dashboard-form-lable">Shot Strike</label>
                        <div className="w-60">
                            {/* <div className={`custom-select-wrapper mb-3 w-100 ${dropdownState.isOpen3 ? 'open' : ''}`}>
                                        <div
                                            className={`selected-option ${defaultSelected ? 'selected' : ''}`}
                                        >
                                            <div className="custom-option-label2">
                                                <span className="option-text">
                                                    {defaultSelected && defaultSelected[step] && defaultSelected[step][iron] && defaultSelected[step][iron].shot1 && defaultSelected[step][iron].shot1.option3 ? defaultSelected[step][iron].shot1.option3 : 'Shot Strike'}
                                                </span>
                                            </div>
                                            <i className={`bi ${dropdownState.isOpen3 ? 'bi-chevron-up' : 'bi-chevron-down'}`} />
                                        </div>
                                    </div> */}
                            <div className='drop-down-wrapper d-flex gap-3'>
                                <div className={`custom-select-wrapper w-50 ${dropdownState.isOpenx ? 'open' : ''}`}>
                                    <div className={`selected-option ${defaultSelected && defaultSelected[step] && defaultSelected[step][iron] && defaultSelected[step][iron].shot3 && defaultSelected[step][iron].shot3.optionx ? 'selected' : ''}`}>
                                        <div className="custom-option-label2">
                                            <span className="option-text">{defaultSelected[step][iron].shot3.optionx ? defaultSelected[step][iron].shot3.optionx : <FaArrowsAltH />}</span>
                                        </div>
                                        <i className={`bi ${dropdownState.isOpenx ? 'bi-chevron-up' : 'bi-chevron-down'}`} />
                                    </div>
                                </div>

                                <div className={`custom-select-wrapper w-50 ${dropdownState.isOpeny ? 'open' : ''}`} >
                                    <div className={`selected-option ${defaultSelected && defaultSelected[step] && defaultSelected[step][iron] && defaultSelected[step][iron].shot3 && defaultSelected[step][iron].shot3.optiony ? 'selected' : ''}`}>
                                        <div className="custom-option-label2">
                                            <span className="option-text">{defaultSelected[step][iron].shot3.optiony ? defaultSelected[step][iron].shot3.optiony : <FaArrowsAltV />}</span>
                                        </div>
                                        <i className={`bi ${dropdownState.isOpenx ? 'bi-chevron-up' : 'bi-chevron-down'}`} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="custom-form-group new-design-form-group">
                        <label className="dashboard-form-lable">Shot Shape</label>
                        <div className="w-60">

                            <div className={`custom-select-wrapper w-100 ${dropdownState3.isOpen1 ? 'open' : ''}`}>
                                <div
                                    className={`selected-option ${defaultSelected ? 'selected' : ''}`}
                                >
                                    <div className="custom-option-label2">
                                        <span className="option-text">
                                            {defaultSelected && defaultSelected[step] && defaultSelected[step][iron] && defaultSelected[step][iron].shot3 && defaultSelected[step][iron].shot3.option1 ? defaultSelected[step][iron].shot3.option1 : 'Shot Shape'}
                                            {/* {defaultSelected[step][iron].shot3.option1 ? defaultSelected[step][iron].shot3.option1 : 'Shot Shape'} */}
                                        </span>
                                    </div>
                                    <i className={`bi ${dropdownState3.isOpen1 ? 'bi-chevron-up' : 'bi-chevron-down'}`} />
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className="custom-form-group new-design-form-group">
                        <label className="dashboard-form-lable">Shot Result</label>
                        <div className="w-60">

                            <div className={`custom-select-wrapper w-100 ${dropdownState3.isOpen2 ? 'open' : ''}`}>
                                <div
                                    className={`selected-option ${defaultSelected ? 'selected' : ''}`}
                                >
                                    <div className="custom-option-label2">
                                        <span className="option-text">
                                            {defaultSelected && defaultSelected[step] && defaultSelected[step][iron] && defaultSelected[step][iron].shot3 && defaultSelected[step][iron].shot3.option2 ? defaultSelected[step][iron].shot3.option2 : 'Shot Result'}
                                            {/* {defaultSelected[step][iron].shot3.option2 ? defaultSelected[step][iron].shot3.option2 : 'Shot Result'} */}
                                        </span>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default IronsData;
